import { Checkbox, Text } from "@clipboard-health/ui-components";
import { FormControlLabel } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { type Worker } from "@src/appV2/Worker/api/types";
import { type Control, Controller } from "react-hook-form";

import { type SignedAtStage } from "../../paths";
import { type SignJobSearchAgreementFormValues } from "../hooks/useJobSearchAgreementForm";

const CHECKBOX_LABEL_PREFIX =
  "By checking this box, you are signing this agreement electronically and agreeing to have your electronic signature in the name of ";
const CHECKBOX_LABEL_SUFFIX = " added to the agreement.";

interface JobSearchAgreementConfirmationCheckboxProps {
  worker: Worker;
  control: Control<SignJobSearchAgreementFormValues>;
  agreementVersion?: number;
  signedAtStage: SignedAtStage;
  placementId?: string;
}

export function JobSearchAgreementConfirmationCheckbox(
  props: JobSearchAgreementConfirmationCheckboxProps
) {
  const { worker, control, agreementVersion, signedAtStage, placementId } = props;

  return (
    <Controller
      name="confirmation"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={field.value}
              sx={{ alignSelf: "flex-start", marginRight: 2 }}
              onChange={(event) => {
                field.onChange(event.target.checked);
                if (event.target.checked) {
                  logEvent(APP_V2_USER_EVENTS.JOB_SEARCH_AGREEMENT_CHECKBOX_CHECKED, {
                    workerId: worker.userId,
                    agreementVersion,
                    signedAtStage,
                    placementId,
                  });
                }
              }}
            />
          }
          label={
            <Text variant="body2" sx={{ color: "primary.main" }}>
              {CHECKBOX_LABEL_PREFIX}
              <b>{worker.name}</b>
              {CHECKBOX_LABEL_SUFFIX}
            </Text>
          }
        />
      )}
    />
  );
}
